import React from 'react';

import {
  ChatIcon,
  EditPenIcon,
  ListIcon,
  NoteIcon,
  TaskIcon,
  ThunderIcon,
} from 'app/shared/componentsRestyled/coreDesignSystem/icons';

import { IconSize } from 'constants/coreDesignSystem';

import { SearchCategory } from '../../../../UniversalSearch.constants';

const ICON_SIZE = IconSize[16];

const NavigationIcon = () => (
  <svg
    fill="none"
    height={ICON_SIZE}
    viewBox="0 0 16 16"
    width={ICON_SIZE}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 8H13M13 8L9 4M13 8L9 12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export const FieldIcon = () => <EditPenIcon size={ICON_SIZE} />;
const ActionIcon = () => <ThunderIcon size={ICON_SIZE} />;
const RecordIcon = () => <ListIcon size={ICON_SIZE} />;
export const RecordFieldIcon = () => <EditPenIcon size={ICON_SIZE} />;
const DocumentIcon = () => <NoteIcon size={ICON_SIZE} />;
const ConditionIcon = () => <TaskIcon size={ICON_SIZE} />;
const ContactsIcon = () => <ChatIcon size={ICON_SIZE} />;

export const CATEGORY_ICON_MAP = {
  [SearchCategory.NAVIGATION]: NavigationIcon,
  [SearchCategory.FIELDS]: FieldIcon,
  [SearchCategory.ACTIONS]: ActionIcon,
  [SearchCategory.RECORDS]: RecordIcon,
  [SearchCategory.DOCUMENTS]: DocumentIcon,
  [SearchCategory.CONDITIONS]: ConditionIcon,
  [SearchCategory.CONTACTS]: ContactsIcon,
};
